export default {
  getKeywordHistory: (state) => state.keywordHistory,
};
